import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const downloadStrings = (userId) => {
    return new Promise((resolve, reject) => {
        axios({
          method : "GET",
          url :  api_url + "/profile/DownloadStrings",
          params : {"userId": userId},
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const addString = (userId, stringUserId) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('userId', userId);
        fdd.append('stringUserId', stringUserId);

        axios({
          method : "POST",
          url :  api_url + "/AddString",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const acceptString = (userId, stringUserId) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('userId', userId);
        fdd.append('stringUserId', stringUserId);

        axios({
          method : "POST",
          url :  api_url + "/AcceptString",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const removeStrings = (connectionId) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('connectionId', connectionId);

        axios({
          method : "POST",
          url :  api_url + "/RemoveStrings",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}